<section class="main-section">
  <form>
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <div class="form-group required">
            <input type="text" id="address1" [(ngModel)]="address1" class="form-control" [ngModelOptions]="{standalone: true}"   required>
            <label class="control-label" for="address1">userName</label>
          </div>
          <div class="form-group required">
            <input type="text" id="address2" [(ngModel)]="address2" class="form-control" [ngModelOptions]="{standalone: true}"   required>
            <label class="control-label" for="address2">hostName</label>
          </div>
          <div class="form-group required">
            <input type="text" id="city" [(ngModel)]="city" class="form-control" [ngModelOptions]="{standalone: true}"   required>
            <label class="control-label" for="city">storeType</label>
          </div>
          <div class="form-group required">
            <input type="text" id="accountStateAlt" [(ngModel)]="state" class="form-control" [ngModelOptions]="{standalone: true}"   required>
            <label class="control-label" for="accountStateAlt">password</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col text-right">
        <button type="reset"  class="btn btn-cancel">Cancel</button>
        <button type="submit"  class="btn btn-orange">Save</button>
      </div>
    </div>
  </form>
</section>
